import { isEmpty } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import content from 'content/pages';

import { storage, service, mdComponentMap } from './helpers';
import { Wrapper } from './styled';

export type ContentSlotProps = {
  slot: string;
};

const ContentSlot: React.FC<ContentSlotProps> = ({ slot }) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    (async () => {
      if (content[slot]) {
        const item = storage.getItem(content[slot]);
        if (!isEmpty(item)) {
          setValue(item.data);
        }
        // Update the content every 15 minutes
        if (isEmpty(item) || item.ts > +new Date() + 15 * 60 * 1000) {
          const data = await service.getSlot(content[slot]);
          setValue(data);
          storage.clearMatching(new RegExp(`${storage.key}..+static/media/${slot}`));
          storage.setItem(slot, { ts: +new Date(), data });
        }
      }
    })();
  }, [slot]);
  return (
    <Wrapper>
      <ReactMarkdown components={mdComponentMap}>{value}</ReactMarkdown>
    </Wrapper>
  );
};

export default ContentSlot;
